import { createAction } from '@reduxjs/toolkit';

export const updateRecords = createAction('parts/updateRecord');

export const updateCount = createAction('parts/updateCount');
